import React, {useState, useEffect, useContext} from "react";

import Select from 'react-select';
import Swal from 'sweetalert2'

import './Checklist.css';

import TareasSubtabla from "../../components/tareasSubtabla/TareasSubtabla";
import { estructuraChecklist, estructuraTarea } from "../../utils/estructuras";
import activoTypeContext from "../../context/activoTypeContex/activoTypeContex";
import FormChecklist from "../../components/formChecklist/FormChecklist";
import ChecklistList from "../../components/checklistList/ChecklistList";

import controlContext from "../../context/controlesContext/controlContex";

import checklistContext from "../../context/checklistContext/checklistContext";

const Checklist = () =>{

    const [showABM,setShowABM] = useState(true); //Indica si se visualiza ABM o se renderiza el formulario de Procedimiento
    const [checklistToModify,setChecklistToModify] = useState({});

    const cContext = useContext(checklistContext)
    const {actualizarChecklistList,eliminarChecklist,checklistList,getCheckByID} = cContext;
    
    useEffect(()=>{
        actualizarChecklistList();
    },[])
    
    return <div className="checklistView">
        {showABM ? <ChecklistList checklists={checklistList} setChecklistToModify={setChecklistToModify} setShowABM={setShowABM} getCheckByID={getCheckByID} eliminarChecklist={eliminarChecklist} actualizarChecklistList={actualizarChecklistList}/> : <FormChecklist checklistToModify={checklistToModify} setShowABM={setShowABM} setChecklistToModify={setChecklistToModify} actualizarChecklistList={actualizarChecklistList}/>}
    </div>

}

export default Checklist;